import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  signal,
} from '@angular/core';
import { TooltipPosition } from '../utils/tooltip-position.type';

type TooltipClassValue =
  | string
  | string[]
  | Record<string, boolean>
  | null;

@Component({
  selector: 'lib-ui-tooltip',
  standalone: false,
  templateUrl: './ui-tooltip.component.html',
  styleUrl: './ui-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTooltipComponent {
  readonly messageInput = signal('');
  readonly positionInput = signal<TooltipPosition>('top');
  readonly tooltipClassInput = signal<TooltipClassValue>(null);

  @HostBinding('class')
  get hostClasses(): string {
    return `ui-tooltip-host ui-tooltip-host--${this.positionInput()}`;
  }
}
